import { string, object, bool } from 'prop-types';
import React, { useState } from 'react';
import { getQaKey as qa } from '../../util/qa';
import EyeIcon from '../icons/EyeIcon';
import TextLabel from './TextLabel';
import TextField from './TextField';
import useStyles from '../../hooks/useStyles';
import useUniqueId from '../../hooks/useUniqueId';

PasswordField.propTypes = {
	'data-qa': string,
	className: string,
	label: string,
	required: bool,
	style: object
};

export default function PasswordField({ className, label, style, 'data-qa': qaKey, ...inputProps }) {
	const [showPassword, setShowPassword] = useState(false);
	const classes = useStyles(styles);

	const onSeePasswordClick = () => {
		setShowPassword(!showPassword);
	};

	const id = useUniqueId('password-field');

	return (
		<div className={className} style={style} {...qa(qaKey)}>
			{label && (
				<TextLabel css={classes.label} htmlFor={id}>
					{label}
				</TextLabel>
			)}
			<div css={classes.inputContainer}>
				<TextField
					{...inputProps}
					css={classes.input}
					id={id}
					type={showPassword ? 'text' : 'password'}
					{...(qaKey && qa('input:text'))}
				/>
				<button css={classes.icon} className={'button-clear'} onClick={onSeePasswordClick} tabIndex={-1} type="button">
					<EyeIcon css={classes.eye} closed={!showPassword} aria-hidden />
					<span className={'sr-only'}>{`${showPassword ? 'Hide' : 'Show'} password`}</span>
				</button>
			</div>
		</div>
	);
}

function styles({ css, theme: { color } }) {
	return {
		inputContainer: css`
			position: relative;
		`,
		label: css`
			margin-bottom: 8px;
		`,
		error: css`
			margin-top: 8px;
		`,
		icon: css`
			position: absolute;
			right: 0;
			top: 4px;
			height: 32px;
			width: 32px;
			display: flex;
			align-items: center;
			fill: ${color.muted};
			transition: fill 0.2s;
			&:hover {
				fill: ${color.text};
			}
		`,
		eye: css`
			width: 24px;
		`
	};
}
